import { useTrace } from '@local/web-design-system-2/dist/utils/trace';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Outlet } from 'react-router';

import { SideBar, COLLAPSED_WIDTH } from 'src/components/side-bar';
import { TopBar } from 'src/components/top-bar';

import { useStyles } from './Layout.styles';

export const Layout = () => {
    const { classes } = useStyles();
    const applyTrace = useTrace('content-div');

    return (
        <div className={classes.mainContainer}>
            <SideBar />
            <AppBar
                position="fixed"
                color="default"
                elevation={1}
                sx={{
                    width: `calc(100% - ${COLLAPSED_WIDTH}px)`,
                    ml: `${COLLAPSED_WIDTH}px`,
                }}
            >
                <Toolbar variant="dense" disableGutters>
                    <TopBar />
                </Toolbar>
            </AppBar>
            <main className={classes.appContent} automation-id={applyTrace()}>
                <div className={classes.pageContent}>
                    <Outlet />
                </div>
            </main>
        </div>
    );
};
